import { Controller } from "@hotwired/stimulus"
export default class TurboController extends Controller {
    initialize() {
        if(this.element.dataset.action == undefined){
            this.element.dataset.action = "click->turbo#click"
        }
    }

    click(e) {
        e.preventDefault()
        this.url = this.element.getAttribute("href")
        fetch(this.url, {
            headers: {
                Accept: "text/vnd.turbo-stream.html"
            }
        })
            .then(r => r.text())
            .then(html => Turbo.renderStreamMessage(html))
    }
}